import React from 'react';

function Download() {
  return (
    <section id="download" className="py-20 px-4 sm:px-6 lg:px-8 gradient-bg">
      <div className="max-w-7xl mx-auto">
        <div className="text-center text-white">
          <h2 className="text-3xl sm:text-4xl font-bold mb-4">
            حمّل تطبيق AWA الآن
          </h2>
          <p className="text-lg sm:text-xl mb-12 opacity-90">
            ابدأ رحلتك العقارية اليوم - متوفر مجاناً على iOS و Android
          </p>

          <div className="flex flex-col sm:flex-row gap-6 justify-center items-center mb-12">
            {/* App Store Button */}
            <a
              href="https://apps.apple.com/us/app/awa-aqar/id6761497066"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-white text-awa-dark px-8 py-4 rounded-2xl font-bold flex items-center gap-4 hover:shadow-2xl transition-all duration-300 transform hover:scale-105"
            >
              <svg className="w-10 h-10" viewBox="0 0 24 24" fill="currentColor">
                <path d="M17.05 20.28c-.98.95-2.05.8-3.08.35-1.09-.46-2.09-.48-3.24 0-1.44.62-2.2.44-3.06-.35C2.79 15.25 3.51 7.59 9.05 7.31c1.35.07 2.29.74 3.08.8 1.18-.24 2.31-.93 3.57-.84 1.51.12 2.65.72 3.4 1.8-3.12 1.87-2.38 5.98.48 7.13-.57 1.5-1.31 2.99-2.54 4.09l.01-.01zM12.03 7.25c-.15-2.23 1.66-4.07 3.74-4.25.29 2.58-2.34 4.5-3.74 4.25z"/>
              </svg>
              <div className="text-right">
                <div className="text-xs opacity-70">حمّل من</div>
                <div className="text-xl font-bold">App Store</div>
              </div>
            </a>

            {/* Google Play Button */}
            <a
              href="https://play.google.com/store/apps/details?id=com.awa.realestatepriv"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-white text-awa-dark px-8 py-4 rounded-2xl font-bold flex items-center gap-4 hover:shadow-2xl transition-all duration-300 transform hover:scale-105"
            >
              <svg className="w-10 h-10" viewBox="0 0 24 24" fill="currentColor">
                <path d="M3,20.5V3.5C3,2.91 3.34,2.39 3.84,2.15L13.69,12L3.84,21.85C3.34,21.6 3,21.09 3,20.5M16.81,15.12L6.05,21.34L14.54,12.85L16.81,15.12M20.16,10.81C20.5,11.08 20.75,11.5 20.75,12C20.75,12.5 20.5,12.92 20.16,13.19L17.89,14.5L15.39,12L17.89,9.5L20.16,10.81M6.05,2.66L16.81,8.88L14.54,11.15L6.05,2.66Z"/>
              </svg>
              <div className="text-right">
                <div className="text-xs opacity-70">حمّل من</div>
                <div className="text-xl font-bold">Google Play</div>
              </div>
            </a>
          </div>

          {/* QR Code */}
          <div className="bg-white rounded-2xl p-8 max-w-md mx-auto">
            <div className="text-awa-dark mb-4 font-bold text-lg">
              امسح الكود للتحميل المباشر
            </div>
            <div className="flex items-center justify-center">
              <img 
                src="/images/qr-code.png" 
                alt="QR Code للتحميل" 
                className="w-64 h-64 object-contain"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Download;
